import { makeStyles, tokens } from '@fluentui/react-components';
import React, { PropsWithChildren } from 'react';

import { Flex } from '@tdp/common/fluentV9MigrationComponents';

const useAppPageStyles = makeStyles({
  appPage: {
    padding: '32px 20px',
    backgroundColor: tokens.colorNeutralBackground3,
    width: 'unset',
    overflowY: 'auto',
    height: '100%'
  }
});

export const AppPage = ({ children }: PropsWithChildren<object>) => {
  const classes = useAppPageStyles();

  return (
    <Flex id="main" column fill gap="gap.medium" className={classes.appPage} >
      {children}
    </Flex>
  );
};
